import { defineMessages } from 'react-intl-next';

export default defineMessages({
	sendButtonLabel: {
		id: 'ai-mate.inline-chat-input.send-button.label',
		defaultMessage: 'Submit',
		description: 'Label for the send button',
	},
	chatInputAssistiveLabel: {
		id: 'ai-mate.inline-chat-input.chat-input-assistive-label',
		defaultMessage: 'Describe what you want to do...',
		description: 'Assistive label for the Rovo inline chat input',
	},
});
